import { DEFAULT_API_KEY_VALUE, DUPLICATE_CI_BUILD_ID_ERROR, INVALID_API_KEY_ERROR, INVALID_PROJECT_KEY_ERROR, RUN_WAS_STOPPED_ERROR, } from "@constants/common";
import { ERRORS } from "@constants/texts/errors";
import { AxiosError } from "axios";
import consoleLogFormatted from "consoleLogFormatted";
import { isErrorCodeExempted } from "./common";
export const handleKnownErrors = (error, self) => {
    var _a, _b;
    const { error: responseError } = error &&
        (error instanceof AxiosError
            ? (((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) || {
                error: undefined,
            })
            : { error: undefined });
    const status = error &&
        (error instanceof AxiosError ? (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.status : undefined);
    self.shouldNotReportTest = true;
    if (responseError === INVALID_PROJECT_KEY_ERROR && status === 404) {
        consoleLogFormatted.redText(ERRORS.onBegin.invalidProjectKey);
        process.exit(1);
    }
    else if (responseError === INVALID_API_KEY_ERROR && status === 401) {
        consoleLogFormatted.redText(ERRORS.onBegin.invalidApiKey);
        process.exit(1);
    }
    else if (self.apiKey === DEFAULT_API_KEY_VALUE) {
        consoleLogFormatted.redText(ERRORS.onBegin.invalidApiKey);
        process.exit(1);
    }
    else if ([DUPLICATE_CI_BUILD_ID_ERROR, RUN_WAS_STOPPED_ERROR].includes(responseError || "") &&
        status === 422) {
        consoleLogFormatted.redText(ERRORS.onBegin.duplicateCiBuildId);
        process.exit(1);
    }
    else {
        if (status === 422) {
            process.kill(process.pid, "SIGKILL");
            process.exit(1);
        }
        isErrorCodeExempted(status) &&
            consoleLogFormatted.yellowText(responseError !== null && responseError !== void 0 ? responseError : error === null || error === void 0 ? void 0 : error.message);
        consoleLogFormatted.yellowText(ERRORS.onBegin.testsWillNotBeReported);
    }
};
//# sourceMappingURL=errorHandler.js.map